import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { RegistrationService } from 'src/app/services/http/business/registration/registration.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AccountService } from 'src/app/services/http/business/account/account.service';
import { DiscountGroupService } from 'src/app/services/http/business/discount-group/discount-group.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { InvoiceSummaryComponent } from '../../finance/payment/invoice-summary/invoice-summary.component';
import { IDiscountgGroup } from 'src/app/interfaces/discount-group';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-direct-register',
  templateUrl: './direct-register.component.html',
  styleUrls: ['./direct-register.component.css']
})
export class DirectRegisterComponent implements OnInit {

  form: FormGroup;

  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();
  nationalCode: any;
  showSubmit: boolean;
  discountList: IDiscountgGroup[] = [];
  userInfo: any;
  showTable: boolean;
  personDiscountGroup: string;
  discountGroupList = [];
  showDiscount = false;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    public translate: TranslateService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private registrationService: RegistrationService,
    private discountGroupService: DiscountGroupService,
    private accountService: AccountService,
    private dialogRef: MatDialogRef<DirectRegisterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  ngOnInit() {
    this.createForm()
  }

  createForm() {
    this.form = this.fb.group({
      SearchNationalCode: [
        null,
        Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(12)])
      ],
      NationalCode: [
        null,
        Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(12)])
      ],
      CourseId: [this.data.CourseId],
      DiscountGroupId: [null]
    });
  }

  getUserInfo(data: any) {
    this.errors = new Array();
    this.accountService.getSimpleUserInfo(data.SearchNationalCode).subscribe(
      res => {
        this.form.controls['NationalCode'].setValue(data.SearchNationalCode)
        this.showSubmit = true;
        this.userInfo = res.FullName;
        this.showTable = false;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      }
    );
  }

  getDiscountPerson(data: any) {
    this.discountGroupService.discountPersonByNationalCodeDirect(this.data.CourseId, data.NationalCode).subscribe(res => {


      if (res && res.length > 0) {
        this.discountList = res
        var dis = res.reduce(function (prev, current) {
          return (prev.DiscountPercent > current.DiscountPercent) ? prev : current
        })

        // var dis = Math.max.apply(Math, res.map(function (o) { return o.DiscountPercent; }))

        this.form.controls['DiscountGroupId'].patchValue(dis.Id);
        // this.model.discountGroupId = dis.Id;
        this.personDiscountGroup = dis.Title;
      }
      else {
        this.form.controls['DiscountGroupId'].patchValue(null);
      }


      this.discountGroupList = res;
      this.showDiscount = true;
    },
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("error.getPersonDiscount"),
          "ok",
          5000,
          SoundEnum.beep
        );
      })
  }

  submit(data: any) {
    this.errors = new Array();
    let model = {
      NationalCode: data.NationalCode,
      CourseId: data.CourseId,
      DiscountGroupId: data.DiscountGroupId
    }
    this.registrationService.addWithOutPlacement(model).subscribe(res => {
      //this.dialogRef.close();
      if (res.returnValue > 0) {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.dialog.open(InvoiceSummaryComponent, {
          width: '98%',
          data: { Id: res.returnValue }
        })
          .afterClosed()
          .subscribe(() => {
            this.dialogRef.close();
          });
      }
      if (res.returnValue == 0) {
        this.snackBar.OpenSnackBar(
          'ثبت دانشجو در کلاس خصوصی انجام شد',
          "ok",
          5000,
          SoundEnum.beep
        );
        this.dialogRef.close();
      }
    }, err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error)
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
